<template>
<button type="button"
        class="odr-clear-button"
        @click="onclick">
    <slot/>
</button>
</template>
<script>
import '@/scss/blocks/clear-button.scss';

export default {
    props: {
        onclick: {},
    },
};
</script>
